<template>
  <div class="sdk-contianer">
   
    <img src="@/assets/images/sdkImage.png" style="width:600px" />

    <div 
      class="sdk-item" 
      v-for="(itemOne, index) in sdkList" 
      :key="index"
    >
      <div class="caption">{{itemOne.name}}</div>
      <p v-if="index == 0" class="remark">如果不集成SDK，可以拉取合约服务镜像，启动容器。采用Http接口形式，调用合约服务里的方法，与链进行交互。如：合约发布，合约调用，查链信息等。</p>
      <div 
        style="font-size:17px;margin-bottom:20px" 
        v-for="(itemTow, index) in itemOne.twoTitles" 
        :key="index"
      >
        <span v-if="itemTow.name != itemOne.name">{{itemTow.name}}</span>
        <div
          style="font-size:14px" 
          v-for="(itemThird, index) in itemTow.thirdTitles"
          :key="index"
        >
          <span>{{itemThird.title3}}：</span>
          <a v-if="itemThird.url" :href="itemThird.url" target="_blank">{{itemThird.name}}</a>
          <span v-else>{{itemThird.name}}</span>
        </div>
      </div>
      <hr v-if="index == 0" />
    </div>
  </div>
</template>
<script>
import { getSdkList } from "@/api/interface";
export default {
  data() {
    return {
      sdkList: [],
    };
  },
  
  created() {
    this.getSdkData();
  },
  methods: {
    async getSdkData() {
      const { data } = await getSdkList();
      this.sdkList = data.oneTitles;
      console.log(this.sdkList);
    },
  },
};
</script>
<style lang="scss" scoped>
.sdk-contianer {
  padding-left: 30px;
  padding-top: 10px;
  text-align: left;
 
  .sdk-item {
    .caption {
      color: #333;
      font-size: 22px;
      margin: 10px 0 8px;
      font-weight: 500;
    }
  }
  .remark {
    color: red;
    font-size: 12px;
  }
  /*div {*/
  /*  span {*/
  /*    display: inline-block;*/
  /*    margin: 10px 0;*/
  /*   margin-right: 10px;*/
  /*  }*/
  /*}*/
}
</style>
